import styled from "styled-components";
import {styledByDevice} from "../../../../../../../themes/architecture/styled-by-device";

export interface ILanguageSwitcherItemLabelProps {
  isSelected: boolean;
}

const DefaultBox = styled.div<ILanguageSwitcherItemLabelProps>`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  font-family: ${props => props.theme.font.family.regular};
  font-size: 1.4rem;
  line-height: 1;
  color: ${props => props.isSelected ? props.theme.colors.brandSecondary : props.theme.colors.componentTextInfo};
`;

const PcBox = styled(DefaultBox)`
  &:hover {
    color: ${props => !props.isSelected && props.theme.colors.componentTextLight};
  }
`;

const MobileBox = styled(DefaultBox)``;

export const LanguageSwitcherItemLabelDefaultBox = styledByDevice(PcBox, MobileBox);
